// ── useMarketerHide — 정산서 관리 마케터 숨기기(전체 공통) 페이지 훅 ─────────────
//   숨김 상태는 서버(settlement_hidden_marketers)에 저장되고 정산예정금액 위젯에서도 제외된다.
//   useAdminSettlement(마케터 목록)은 손대지 않고, 토글 즉시 반영을 위해 낙관적 오버라이드를 둔다.
//   isMarketerHidden(mk) = 오버라이드 있으면 그 값, 없으면 서버가 준 mk.hidden.
import { useCallback, useEffect, useState } from 'react';
import { apiClient } from '../../../api/apiClient';
import { useToast } from '../../../components/Toast';

export function useMarketerHide({ companyCode = 'PINE' } = {}) {
  const { showToast } = useToast();
  const [showHiddenMarketers, setShowHiddenMarketers] = useState(false);
  const [overrides, setOverrides] = useState({}); // { [userId]: boolean } 낙관적

  // 회사 바뀌면 오버라이드 초기화(새 목록의 서버 hidden 값을 그대로 신뢰)
  useEffect(() => { setOverrides({}); }, [companyCode]);

  const isMarketerHidden = useCallback(
    (mk) => (Object.prototype.hasOwnProperty.call(overrides, mk.id) ? overrides[mk.id] : Boolean(mk.hidden)),
    [overrides],
  );

  const toggleMarketerHidden = useCallback(async (mk, nextHidden) => {
    const res = await apiClient.put(`/api/admin/settlement/marketers/${mk.id}/hidden`, {
      companyCode,
      hidden: nextHidden,
    });
    if (!res.ok) {
      showToast(res.data?.message || '숨김 설정에 실패했습니다.', 'error');
      return;
    }
    setOverrides((prev) => ({ ...prev, [mk.id]: nextHidden }));
    showToast(nextHidden ? `${mk.name} 숨김 처리됨` : `${mk.name} 다시 표시됨`, 'success');
  }, [companyCode, showToast]);

  return { showHiddenMarketers, setShowHiddenMarketers, isMarketerHidden, toggleMarketerHidden };
}
